import news from "./news";
import topic from "./topic";
import banner from "./banner";
import logs from "./logs";
import quiz from "./quiz";
import users from "./users";
import settings from "./settings";
import pages from "./pages";
import region from "./region";
import greeting from "./greeting";
import dictionaries from "./dictionaries"
import budgets from "./budgets"
import corporateResources from "./corporate-resources";
import pageCategories from "./page-categories";
import documentTypes from "./document-types";
import shippingMethods from "./shipping-methods";
import documentCategories from "./document-categories";
import drivers from "@/routers/admin/drivers";
import halls from "@/routers/admin/halls";

const routers = [
  {
    path: '/admin',
    redirect: '/admin/news',
    component: () => import('@/layouts/LayoutAdmin.vue'),
    children: [
      ...news,
      ...topic,
      ...banner,
      ...quiz,
      ...users,
      ...settings,
      ...logs,
      ...pages,
      ...region,
      ...greeting,
      ...dictionaries,
      ...budgets,
      ...corporateResources,
      ...pageCategories,
      ...documentTypes,
      ...documentCategories,
      ...shippingMethods,
      ...drivers,
      ...halls,
    ],
  },
]
export default routers
